
<template>
  <!--eslint-disable-->
  <v-dialog
    persistent
    v-model="unitsDialog"
    max-width="70%"
    height="70vh"
    :fullscreen="$vuetify.breakpoint.mobile"
  >
    <v-card flat class="exemptions">
      <v-toolbar flat dark sticky color="primary" elevation="0">
        <v-toolbar-title class="text-lg-h6 mx-auto d-flex mt-3">
          <span class="mr-1">{{ formData.programme }} &nbsp;</span> Exemptible
          Units
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text
        class="overflow-y-auto overflow-x-hidden"
        style="max-height: 70vh"
      >
        <v-data-table
          :headers="headers"
          :items="exemptibleUnits"
          hide-default-footer
          item-key="code"
        >
          <template v-slot:[`item.description`]="{ item }">
            <div class="d-flex">
              <span class="font-weight-bold">{{ item.code }}: </span>
              <span class="ml-2">{{ item.description }}</span>
            </div>
          </template>
          <template v-slot:[`item.exemptionFees`]="{ item }">
            {{ item.exemptionFees | currencyFormat }}
          </template>
          <template v-slot:[`item.comparableUnits`]="{ item }">
            <v-autocomplete
              :items="item.comparableUnits"
              :item-text="(item) => item.description"
              :item-value="(item) => item.code"
              v-model="setComparableUnits"
              :disabled="item.isNotExempted"
              :rules="rules.required"
              @input="setComparableUnitsFunc(item, $event)"
              class="mt-5 autocomplete"
              label="Comparable Units"
              return-object
              outlined
              dense
            />
          </template>
          <template v-slot:[`item.educationLevels`]="{ item }">
            <v-autocomplete
              :items="educationLevels"
              :item-text="
                (item) =>
                  item.type +
                  ': ' +
                  item.institution +
                  ': ' +
                  item.certificateAwarded +
                  ', ' +
                  item.areaOfSpecialization
              "
              :item-value="(item) => item.lineNo"
              v-model="setEducationLevels"
              :disabled="item.isNotExempted"
              :rules="rules.required"
              @input="setEducationLevelsFunc(item, $event)"
              class="mt-5 autocomplete"
              label="Education Level"
              return-object
              outlined
              dense
            />
          </template>
          <template v-slot:[`item.select`]="{ item }">
            <v-layout>
              <v-checkbox
                small
                :value="item"
                class="shrink mr-2"
                v-model="formData.examExemptionLines"
              ></v-checkbox>
            </v-layout>
          </template>
          <template v-slot:[`item.grade`]="{ item }">
            <v-select
              dense
              outlined
              v-model="setGrade"
              @input="setGradeFunc(item, $event)"
              :items="grades"
              class="mt-4 select"
              return-object
              label="Grade"
              :disabled="item.isNotExempted"
              ref="grade"
              :item-text="(item) => item.description"
              :item-value="(item) => item.code"
              :rules="rules.required"
            />
          </template>
        </v-data-table>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" @click="selectedUnits">done</v-btn>
        <v-btn outlined color="error" @click="closeDialog"> close </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/* eslint-disable */
export default {
  name: "ExemptibleUnits",
  props: {
    exemptionUnitsDialogBox: Boolean,
    formData: Object,
  },
  data() {
    return {
      other: false,
      headers: [
        {
          text: "Units",
          align: "start",
          sortable: false,
          value: "description",
        },
        { text: "Education Level", value: "educationLevels" },
        { text: "Comparable Units", value: "comparableUnits" },
        { text: "Exemption Fees (KES)", value: "exemptionFees" },
        { text: "Exempt", value: "select", sortable: false },
        { text: "Grade", value: "grade" },
      ],
    };
  },
  computed: {
    unitsDialog: {
      get() {
        return this.exemptionUnitsDialogBox;
      },
      set(value) {
        this.setExemptionUnitsModal(value);
      },
    },
    exemptibleUnits() {
      const units =
        this.$store.getters["Exemption/exemptionGetter"]("exemptibleUnits");
      return units.filter((item) => {
        const unit = this.formData.examExemptionLines.filter(
          (el) => el.unit === item.code && el.lineNo,
        ).length;
        item.isNotExempted =
          this.formData.examExemptionLines.filter((el) => el.code === item.code)
            .length === 0;
        return item.exemptible === true && unit === 0;
      });
    },
    rules() {
      return {
        required: [(v) => !!v || "field is required"],
      };
    },
    grades() {
      return this.$store.getters["Exemption/exemptionGetter"]("grades");
    },
    educationLevels() {
      return this.$store.getters["Profile/academicsGetters"]("academics");
    },
    setGrade: {
      get() {
        return this.formData.examExemptionLines.gradeScored;
      },
      set(value) {
        this.formData.examExemptionLines.gradeScored = value;
      },
    },
    setComparableUnits: {
      get() {
        return this.formData.examExemptionLines.comparableUnit;
      },
      set(value) {
        this.formData.examExemptionLines.comparableUnit = value;
      },
    },
    setEducationLevels: {
      get() {
        return this.formData.examExemptionLines.educationLineNo;
      },
      set(value) {
        this.formData.examExemptionLines.educationLineNo = value;
      },
    },
  },
  methods: {
    setExemptionUnitsModal(value) {
      this.$emit("setExemptionUnitsModal", value);
    },
    closeDialog() {
      this.unitsDialog = false;
      this.other = false;
    },
    selectedUnits() {
      this.unitsDialog = false;
    },
    uppercase() {
      this.formData.examExemptionLines.grade =
        this.formData.examExemptionLines.grade.toUpperCase();
    },
    setGradeFunc(item, event) {
      this.formData.examExemptionLines.map((el) => {
        if (el.code === item.code) {
          el.gradeScored = event.code;
          return el;
        }
      });
    },
    save() {
      this.snack = true;
    },
    cancel() {
      this.snack = true;
    },
    remove(item) {
      const index = this.comparableUnits.indexOf(item.code);
      this.comparableUnits.splice(index, 1);
    },
    setComparableUnitsFunc(item, event) {
      // console.log("item", item, "event", event);
      this.formData.examExemptionLines.map((el) => {
        if (el.code === item.code) {
          el.comparableUnit = event.code;
          return el;
        }
      });
    },
    setEducationLevelsFunc(item, event) {
      // console.log("item", item, "event", event);
      this.formData.examExemptionLines.map((el) => {
        if (el.code === item.code) {
          el.educationLineNo = event.lineNo;
          return el;
        }
      });
    },
  },
};
</script>

<style scoped>
@import url("../styles/exemption.css");
</style>
